import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

export default class PercentageBar extends Component {
    static propTypes = {
        percentage: PropTypes.number.isRequired,
        width: PropTypes.string,
        fillColor: PropTypes.string,
        emptyColor: PropTypes.string,
    };

    render() {
        return (
            <div
                className={styles.root}
                style={{backgroundColor: this.props.emptyColor, width: this.props.width}}>
                <div
                    className={styles.fill}
                    style={{flexBasis: `${this.props.percentage}%`, backgroundColor: this.props.fillColor}}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/percentage-bar/index.js